module.exports = __webpack_public_path__ + "img/PQM-800_freigestellt.8d391331.png";